import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';

@Injectable({
  providedIn: 'root'
})

export class reportRowsResolve  {
    constructor(private apiService: ApiServiceService) { }

    resolve(route: ActivatedRouteSnapshot) {
      return this.apiService.get('reportobjects/data', route.params['reportObjectId'])
        .then((data:any)=>{
          return data
        })
    }
}
